module.exports = __webpack_public_path__ + "img/bookeeping.1c3c8c05.png";